
//TRIP DATA
export const GET_SELECTED_DEVICE_TRIP_DATA = 'GET_SELECTED_DEVICE_DATA';
export const ERROR_SELECTED_DEVICE_TRIP_DATA = 'ERROR_SELECTED_DEVICE_TRIP_DATA';
export const CLEAR_SELECTED_DEVICE_TRIP_DATA = 'CLEAR_SELECTED_DEVICE_TRIP_DATA';

//FILES
export const GET_FILE = 'GET_FILE';
export const ERROR_FILE = 'ERROR_FILE';